class LinkUserEmailAndPassword{
    constructor(){
        this.userId = null;
        this.email = "";
        this.password = "";
    }
}

export default LinkUserEmailAndPassword;